import {FormControl} from 'platform/components';
import {Box, HStack, Text, VStack} from 'platform/foundation';

import {RefObject} from 'react';
import {UseFormReturn} from 'react-hook-form';

import {GetSalesPlatformsApiRes} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {DescriptionGeneratorInputs} from '../types/DescriptionGeneratorInputs';
import {GeneralSettingsFormValues} from '../types/GeneralSettingsFormValues';
import {MultiLanguageContentSection} from './MultiLanguageContentSection';

interface BelgianLanguageVariantsCardProps extends TestIdProps {
  control: FormControl<GeneralSettingsFormValues>;
  enabledLanguages: Array<{value: string; label: string}>;
  vehicleId: string;
  isDisabled: boolean;
  platforms: GetSalesPlatformsApiRes | undefined;
  formApi: UseFormReturn<GeneralSettingsFormValues>;
  descriptionGeneratorInputsRef: RefObject<DescriptionGeneratorInputs | null>;
}

export function BelgianLanguageVariantsCard(props: BelgianLanguageVariantsCardProps) {
  return (
    <Box padding={4} borderRadius="small" backgroundColor="palettes.neutral.20.100">
      <VStack spacing={4}>
        <HStack justify="space-between" align="center">
          <HStack spacing={2} align="center">
            <Text size="small" alternative>
              {i18n.t('page.advertisement.labels.belgianLanguageVariants')}
            </Text>
            <Text size="xSmall" color="informational">
              {`${props.enabledLanguages.length} ${i18n.t('entity.advertisingPlatforms.labels.contentLanguages')}`}
            </Text>
          </HStack>
        </HStack>
        <MultiLanguageContentSection
          control={props.control}
          enabledLanguages={props.enabledLanguages}
          vehicleId={props.vehicleId}
          isDisabled={props.isDisabled}
          platforms={props.platforms}
          formApi={props.formApi}
          descriptionGeneratorInputsRef={props.descriptionGeneratorInputsRef}
        />
      </VStack>
    </Box>
  );
}
